import { render, staticRenderFns } from "./noOpening-deposit.vue?vue&type=template&id=28ae1af2&scoped=true&"
import script from "./noOpening-deposit.vue?vue&type=script&lang=js&"
export * from "./noOpening-deposit.vue?vue&type=script&lang=js&"
import style0 from "./noOpening-deposit.vue?vue&type=style&index=0&id=28ae1af2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ae1af2",
  null
  
)

export default component.exports